import {validateField, submitFields, clearFields} from './helpers/form'
import {
  FETCH_ARTICLE_EDIT_DATA_SUCCESS,
  VALIDATE_ARTICLE_EDIT_FIELD,
  SUBMIT_ARTICLE_EDIT_FIELDS,
  CLEAR_ARTICLE_EDIT_FIELDS
} from '../../../actions/pages/article-page'

export function articleEditForm(
  state = {
    valid: false,
    fields: [
      {
        name: 'Title',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Title',
          required: true
        }
      },
      {
        name: 'Text',
        value: '',
        errors: [],
        rules: {
          title: 'Text'
        }
      },
      {
        name: 'PublishDate',
        value: '',
        errors: [],
        rules: {
          title: 'Publish date',
          required: true
        }
      },
      {
        name: 'IsArchived',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Archived'
        }
      },
      {
        name: 'ImageFile',
        value: '',
        errors: [],
        rules: {
          title: 'Article image (1125 x 810 pixels)'
        }
      },
      {
        name: 'ImageUrl',
        value: '',
        errors: [],
        rules: {
          title: ''
        }
      }
    ]
  },
  action
) {
  switch (action.type) {
    case FETCH_ARTICLE_EDIT_DATA_SUCCESS: {
      let fields = state.fields.map((field) => {
        let newValue;
        Object.entries(action.data).forEach(([key, value]) => {
          if (field.name === key){
            newValue = value;
            return;
          }
        })

        if (newValue !== undefined) {
          return {
            ...field,
            value: newValue,
            errors: []
          }
        }

        return field;
      })

      return Object.assign({}, state, {
        valid: true,
        fields: Array.from(fields)
      })
    }

    case VALIDATE_ARTICLE_EDIT_FIELD: {
      return validateField(state, action);
    }

    case SUBMIT_ARTICLE_EDIT_FIELDS: {
      return submitFields(state, action);
    }

    case CLEAR_ARTICLE_EDIT_FIELDS: {
      return clearFields(state);
    }

    default:
      return state
  }
}
